module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"incipit":"Sorry, {groupByLabel} found | {groupByLabel} found | {groupByLabel} found"},"fr":{},"it":{},"nl":{"summary":"SAMENVATTING","include":"inclusief","exclude":"exclusief","message":"<span class=\u0027number\u0027>{count}</span> artikelen gevonden {terms} {ranges}"}}')
  delete Component.options._Ctor
}
